import { useQuery } from 'react-query';
import { CompanyListResponse } from './companyTypes';
import { getCompanyList } from './companyService';

type Props<M> = {
    onError?: (error: Error) => void;
    onSuccess?: (data: CompanyListResponse) => void;
    mapper?: (
        data?: CompanyListResponse
    ) => M | CompanyListResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: CompanyListResponse) => data;

export const useGetCompanyList = <M = CompanyListResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
}: Props<M>) => {
    const query = useQuery<CompanyListResponse, Error>(
        ['companies'],
        getCompanyList,
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
